import Upsells from "./Layout";

export default Upsells;
